/* Dil seçimi ve arayüz metinleri. İçerik metinleri veritabanından gelir;
   burada yalnızca uygulamanın kendi sabit metinleri var. */

import { useCallback, useEffect, useState } from "react";
import type { Lang } from "../../shared/types.js";

const KEY = "bp:lang";

function initialLang(): Lang {
  if (typeof window === "undefined") return "tr";
  const fromUrl = new URLSearchParams(window.location.search).get("lang");
  if (fromUrl === "tr" || fromUrl === "en") return fromUrl;
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "tr" || stored === "en") return stored;
  } catch {
    /* özel sekmede localStorage kapalı olabilir */
  }
  return navigator.language?.toLowerCase().startsWith("tr") ? "tr" : "en";
}

export function useLang(): [Lang, (l: Lang) => void] {
  const [lang, setLangState] = useState<Lang>(initialLang);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    try {
      localStorage.setItem(KEY, l);
    } catch {
      /* yoksay */
    }
  }, []);

  return [lang, setLang];
}

type Dict = Record<string, { tr: string; en: string }>;

const UI: Dict = {
  navProgram: { tr: "Program", en: "Programme" },
  navDress: { tr: "Dress code", en: "Dress code" },
  navWorkshops: { tr: "Atölyeler", en: "Workshops" },
  navEvening: { tr: "Akşam", en: "Evening" },
  navSpeakers: { tr: "Sahne", en: "Stage" },

  programTitle: { tr: "Günün akışı", en: "The day" },
  programNow: { tr: "Şu an", en: "Now" },
  programNext: { tr: "Sırada", en: "Next" },
  practical: { tr: "Pratik bilgiler", en: "Good to know" },

  dressTitle: { tr: "Dress code", en: "Dress code" },
  workshopsTitle: { tr: "Atölyeler ve Workshoplar", en: "Workshops & Sessions" },
  workshopsLede: {
    tr: "Gün içinde iki aralıkta atölyeler çalışıyor. Karta dokunun, detay açılsın.",
    en: "Workshops run in two windows during the day. Tap a card for the details.",
  },
  eveningTitle: { tr: "Akşam", en: "Evening" },
  speakersTitle: { tr: "Sahne alanlar", en: "On stage" },
  speakersLede: {
    tr: "Sahneye çıkış sırasına göre.",
    en: "In order of appearance.",
  },

  loading: { tr: "Yükleniyor…", en: "Loading…" },
  offline: {
    tr: "İçerik yüklenemedi. Bağlantınızı kontrol edip sayfayı yenileyin.",
    en: "Couldn't load the content. Check your connection and reload.",
  },
  retry: { tr: "Tekrar dene", en: "Try again" },
  more: { tr: "Detay", en: "Details" },
  less: { tr: "Kapat", en: "Close" },
};

export const ui = (key: keyof typeof UI | string, lang: Lang): string => {
  const entry = UI[key];
  return entry ? entry[lang] : key;
};
